import { render, staticRenderFns } from "./TimesPage.vue?vue&type=template&id=c2bbee86&scoped=true&"
import script from "./TimesPage.vue?vue&type=script&lang=js&"
export * from "./TimesPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=c2bbee86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bbee86",
  null
  
)

export default component.exports